var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"phcompany"},[_c('hpheader'),_c('div',{staticClass:"phcomp-cont"},_vm._l((_vm.channel_list),function(item,index){return _c('div',{staticClass:"phcompcont-item",on:{"click":function($event){return _vm.navtomore(item.id)}}},[_vm._v("\n\t\t\t"+_vm._s(item.name)+"\n\t\t")])}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }